import { useRewardForm } from '@/common/reward/form';
import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_LIVEOPS } from '@/modules/liveops/router';
import { useLiveopsReward } from '@/modules/liveops/shared/reward';
import { liveopsPointService } from '@/services/liveops';
import useVuelidate from '@vuelidate/core';
import { minValue, numeric, required } from '@vuelidate/validators';
import { useRoute } from 'vue-router';

export function useLiveopsLeaderboardAdd() {
    const route = useRoute();
    const router = useAppRouter();

    const itemId = StringUtils.toNumber(route.params.itemId);
    const { model, feature } = useRewardForm({
        toRank: null as number | null,
        data: null as number | null,
        quantity: 1
    });

    const { fetchLinkableRewards, rewardOptions } = useLiveopsReward(feature);

    const validations = {
        toRank: { required, numeric, minValue: minValue(1) },
        feature: { required },
        data: { required },
        quantity: { required }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () =>
            liveopsPointService.leaderboard.add(itemId, model.toRank, model.feature, model.data, model.quantity),
        onSuccess: () => router.push({ name: ROUTE_NAME_LIVEOPS.LEADERBOARD.INDEX, params: { itemId } })
    });

    return { model, v$, fetchLinkableRewards, rewardOptions, create };
}
